import React from 'react';

import { IUseControlsProps, useControls } from '../ContextState/useControls';
import { MenuContext } from '../ContextState/useMenuContext';

interface IMenuContextWrapperProps extends IUseControlsProps {
  children: React.ReactNode;
}
export const MenuContextWrapper: React.FC<IMenuContextWrapperProps> = ({
  menuOptions,
  favorites,
  getSubmenuItems,
  onFavoriteDeleteClick,
  onFavoriteReorder,
  onFavoriteSaveClick,
  children,
  hideOpenGovLogo,
  openGovLogoUrl,
  openGovLogoLinkComponent,
  openGovLogoOnClick
}) => {
  const context = useControls({
    menuOptions,
    favorites,
    getSubmenuItems,
    onFavoriteDeleteClick,
    onFavoriteReorder,
    onFavoriteSaveClick,
    hideOpenGovLogo,
    openGovLogoLinkComponent,
    openGovLogoUrl,
    openGovLogoOnClick
  });
  return <MenuContext.Provider value={context}>{children}</MenuContext.Provider>;
};
